var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"2","y":"9.3","width":"20","height":"5.4"}));
}

Minus.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Minus;

Minus.default = Minus;
